import { render, staticRenderFns } from "./RoleMenu.vue?vue&type=template&id=3bd341f8&scoped=true&"
import script from "./RoleMenu.vue?vue&type=script&lang=js&"
export * from "./RoleMenu.vue?vue&type=script&lang=js&"
import style0 from "./RoleMenu.vue?vue&type=style&index=0&id=3bd341f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd341f8",
  null
  
)

export default component.exports